import gql from 'graphql-tag';

export default gql`
  query lowFareFlightCalendar(
    $lowFareCalendarSearchCriteria: LowFareCalendarSearchCriteriaInput!
  ) {
    lowFareFlightCalendar(
      lowFareCalendarSearchCriteria: $lowFareCalendarSearchCriteria
    ) {
      date
      fare {
        salesTotal
        strikethrough
      }
      __typename
    }
  }
`;
